import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  LINKS_MANAGEMENT_CLEAR,
  LINKS_MANAGEMENT_SEARCH_ENGINE_FETCH,
} from '../../../actions/actionTypes';

const searchEngine = fetchReducerGenerator(
  [LINKS_MANAGEMENT_CLEAR],
  LINKS_MANAGEMENT_SEARCH_ENGINE_FETCH
);

export default searchEngine;
